import { combineEpics } from 'redux-observable';

import { values } from 'lodash';

import * as settingsEpics from './portal/settings/epics';
import * as dashboardEpics from './portal/dashboard/epics';
import * as postsEpics from './admin/posts/epics';
import * as placesEpics from './admin/places/epics';
import * as pagesEpics from './admin/pages/epics';
import * as pagetypesEpics from './admin/page-types/epics';
import * as categoryEpics from './admin/categories/epics';
import * as groupsEpics from './admin/groups/epics';
import * as connHeaderEpics from './admin/connection-header/epics';
import * as connectionsEpics from './portal/connections/epics';
import * as noticesEpics from './portal/notices/epics';
import * as audienceEpics from './portal/audiences/epics';
import * as calendarEpics from './portal/calendar/epics';
import * as absencesEpics from './portal/absences/epics';
import * as financialEpics from './portal/financialinfo/epics';
import * as emergencybroadcastEpics from './portal/emergencybroadcast/epics';
import * as sendEmailsEpics from './admin/send-emails/epics';
import * as sendWeeklyEmailEpics from './admin/send-weekly-emails/epics';
import * as emailLogsEpics from './admin/email-logs/epics';
import * as yearinfoEpics from './portal/year-info/epics';
import * as weblogsEpics from './admin/web-logs/epics';
import * as keyLearningAreaEpics from './portal/key-learning-area/epics';
import * as unitsEpics from './portal/course-units/epics';
import * as courseTasksEpics from './portal/course-tasks/epics';
import * as courseClassroomsEpics from './portal/course-classrooms/epics';
import * as myDayTimetableEpics from './portal/my-day-timetable/epics';
import * as teacherDayTimetableEpics from './portal/teacher-day-timetable/epics';
import * as upcomingTasksEpics from './portal/upcoming-tasks/epics';
import * as subscribedUsersEpics from './admin/subscribed-users/epics';
import * as parentDashboardEpics from "./portal/parent-dashboard/epics";
import * as studentGoalsEpics from "./portal/student-goals/epics";
import * as schoolPsychologyService from './portal/school-psychology-request/epics';
import * as learningGoalsPDF from './admin/learning-goals-pdf/epics';
import * as queuePDF from './admin/queue-pdf/epics';
import * as metrics from './portal/metrics/epics';


export default combineEpics(
  ...values(settingsEpics),
  ...values(dashboardEpics),
  ...values(postsEpics),
  ...values(placesEpics),
  ...values(pagesEpics),
  ...values(pagetypesEpics),
  ...values(categoryEpics),
  ...values(groupsEpics),
  ...values(connHeaderEpics),
  ...values(connectionsEpics),
  ...values(noticesEpics),
  ...values(audienceEpics),
  ...values(calendarEpics),
  ...values(absencesEpics),
  ...values(financialEpics),
  ...values(emergencybroadcastEpics),
  ...values(sendEmailsEpics),
  ...values(sendWeeklyEmailEpics),
  ...values(emailLogsEpics),
  ...values(yearinfoEpics),
  ...values(weblogsEpics),
  ...values(keyLearningAreaEpics),
  ...values(unitsEpics),
  ...values(courseTasksEpics),
  ...values(courseClassroomsEpics),
  ...values(myDayTimetableEpics),
  ...values(teacherDayTimetableEpics),
  ...values(upcomingTasksEpics),
  ...values(subscribedUsersEpics),
  ...values(parentDashboardEpics),
  ...values(studentGoalsEpics),
  ...values(schoolPsychologyService),
  ...values(learningGoalsPDF),
  ...values(queuePDF),
  ...values(metrics),
);
